import { render, staticRenderFns } from "./SectionInfopartners.vue?vue&type=template&id=2c768e57"
import script from "./SectionInfopartners.vue?vue&type=script&lang=ts"
export * from "./SectionInfopartners.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports